import type { EpcPreviewSection } from "features/dt-basic-setup/single-building/lib/epcPreviewRows";

import { Accordion, AccordionDetails, AccordionSummary, Stack } from "@mui/material";
import { Icon } from "components/Icon";
import { useTranslation } from "react-i18next";

import { EpcDataRow } from "./EpcDataRow";

type EpcAdditionalSectionsCardProps = {
  sections: EpcPreviewSection[];
};

export const EpcAdditionalSectionsCard = ({ sections }: EpcAdditionalSectionsCardProps) => {
  const { t } = useTranslation();
  return (
    <Stack className="bg-lds-surface-info-softest w-full flex-col items-stretch gap-4 rounded-ds-0-75x border p-5 border-ds-subtle">
      <p className="text-lds-foreground-heading text-left font-ds-body-bold-md">
        {t("AddBuilding.epcModal.preview.additionalTitle")}
      </p>
      <Stack className="w-full flex-col items-stretch gap-2">
        {sections.map((section) => (
          <Accordion className="!rounded-ds-0-5x p-0 !border-ds-subtle before:!hidden" disableGutters key={section.id}>
            <AccordionSummary
              className="!px-4 !py-2 font-ds-body-bold-md"
              expandIcon={<Icon iconName="ChevronDown" size="sm" />}
            >
              <p className="font-ds-body-bold-sm uppercase text-lds-foreground-muted">{section.title}</p>
            </AccordionSummary>
            <AccordionDetails className="!px-4 !pb-4 !pt-0">
              <Stack className="w-full flex-col items-stretch">
                {section.rows.map((row, rowIndex) => (
                  <EpcDataRow key={`${section.id}-${rowIndex}-${row.label}`} row={row} />
                ))}
              </Stack>
            </AccordionDetails>
          </Accordion>
        ))}
      </Stack>
    </Stack>
  );
};
